import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{staticClass:"ma-0 pa-0",attrs:{"hide-details":"","flat":"","solo":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [[_c('div',{style:(_vm.swatchStyle),on:{"click":function($event){return _vm.$emit('edit')}}})]]},proxy:true}]),model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})}
var staticRenderFns = []

export { render, staticRenderFns }